
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as Utils from '@Cyclope-Utils/index';
import {GetZoneByIdCameraLoadedActionFail, GetZoneByIdCameraLoadedActionInProgress, GetZoneByIdCameraLoadedActionReset, GetZoneByIdCameraLoadedActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function GetZoneByIdCameraLoadedActionCreator
 * @param { number } cameraId
 * @return {Promise<any>}  Promise
 */


export function GetZoneByIdCameraLoadedActionCreator(cameraId: number): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(GetZoneByIdCameraLoadedActionInProgress());

    await Utils.fetchTunnelWatchAllZone()
        .then(res => {
          if (res.ok) {
            /**
             * @constant
             * @name contentType
             * @type string
             */
            const contentType: any = res.headers.get('content-type');
            { /** vérification du tyde des entêtes */
            }

            if (contentType && contentType.indexOf('application/json') !== -1) {
              res.json().then((data: any) => {
                if (!data.error) {
                  const Masque = Promise.all(data.map(
                      async (zone: any, index: any) => {
                          return Utils
                              .fetchTunnelWatchZonemaskByCameraId(
                                  cameraId, zone.id)
                              .then(response => response.blob())
                              .then(
                                  (blob) => {
                                      return URL.createObjectURL(blob)})}))

                  Masque.then(
                      (Elem: any) =>
                          dispatch(GetZoneByIdCameraLoadedActionSuccess(Elem)))
                  Masque.catch(
                      (error: any) =>
                          dispatch(GetZoneByIdCameraLoadedActionFail(error)))

                } else {
                  dispatch(GetZoneByIdCameraLoadedActionFail(data.error))
                }
                return data
              })
            }

          } else {
            throw Error(res.statusText + ', server status:' + res.status);
          }
        })
        .catch(
            (error: any) => dispatch(GetZoneByIdCameraLoadedActionFail(
                error.message + ' ,random value:' + Math.random())))
  }
}


/**
 * @function { GetZoneByIdCameraLoadedActionCreator }
 * @param data
 * @return promise
 */


export function GetZoneByIdCameraResetActionCreator(): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(GetZoneByIdCameraLoadedActionReset());
  }
}


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/getmaskbyzone/index.ts